export const DEFAULT_PAGE_SIZE = 12;

export const NETWORK_STATUS = [
  {
    label: "All",
    value: "ALL",
  },
  {
    label: "Enabled",
    value: "ENABLED",
  },
  {
    label: "Disabled",
    value: "DISABLED",
  },
];

export const NETWORK_TYPES = [
  {
    label: "All",
    value: "ALL",
  },
  {
    label: "Mainnet",
    value: "MAINNET",
  },
  {
    label: "Testnet",
    value: "TESTNET",
  },
];

export const NETWORK_ARCHITECTURES = [
  {
    label: "All",
    value: "ALL",
  },
  {
    label: "EVM",
    value: "EVM",
  },
  {
    label: "UTXO",
    value: "UTXO",
  },
];
